<div class="container-fluid">
<div class="card" style="margin:5% auto; width: 50%; height:50%">
  <div class="card-data">

    <h1 class="text-center">
      <span class="fa-stack fa-1x">
        <i class="fa fa-circle fa-stack-2x text-primary"></i>
        <i class="fa fa-user-plus fa-stack-1x fa-inverse"></i>
      </span>Confirm Reset Password
    </h1>
<div class="row">
<div class="col-md-12" *ngIf="isLoading">
  <app-busy [message]="message"></app-busy>
</div>



<div class="col-md-12" style="margin-bottom:5px;margin-top:5px">
  <form autocomplete="nope" [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
    <div class="row">

       <div class="form-group col-md-6">
          <label>New Password</label> <!--New word-->
          <input type="password" name="Password" formControlName="Password" onfocus="this.removeAttribute('readonly');" readonly class="form-control input-sm" [ngModel]="loginUser.Password" autocomplete="one-time-code" [ngClass]="{'error':(form.controls['Password'].touched && form.controls['Password'].invalid)}" #pwd/>
          <div class="invalid-feedback" *ngIf="form.controls['Password'].touched && form.controls['Password'].invalid">
              {{getPasswordErr()}}
          </div>
        </div>
        <div class="form-group col-md-6">
          <label>Confirm Password</label>
          <input type="password" name="ConfirmPassword"
          (blur)="passwordMatch(pwd.value,cnfPwd.value)"
          formControlName="ConfirmPassword" onfocus="this.removeAttribute('readonly');" readonly class="form-control input-sm" [ngModel]="loginUser.ConfirmPassword" autocomplete="one-time-code" [ngClass]="{'error':(form.controls['ConfirmPassword'].touched && form.controls['ConfirmPassword'].invalid)}" #cnfPwd/>
          <span class="invalid-feedback" *ngIf="form.controls['ConfirmPassword'].touched && form.controls['ConfirmPassword'].invalid">
              {{getConfirmPasswordErr()}}
            </span>
        </div>

       <div class="form-group col-md-6">
        <label>Password Reset Code</label>
        <input type="number" name="ResetCode" formControlName="ResetCode" onfocus="this.removeAttribute('readonly');" readonly class="form-control input-sm" autocomplete="off" [ngModel]="loginUser.ResetCode"
        [ngClass]="{'error':(form.controls['ResetCode'].touched && form.controls['ResetCode'].invalid)}" />
        <span class="invalid-feedback" *ngIf="form.controls['ResetCode'].touched && form.controls['ResetCode'].invalid">
          {{getResetCodeErr()}}
        </span>
      </div>


      <div class="form-group col-md-6">
        <label>Email</label>
        <input type="email" name="EmailAddress" formControlName="EmailAddress" onfocus="this.removeAttribute('readonly');" readonly class="form-control input-sm" [ngModel]="loginUser.EmailAddress"
        [ngClass]="{'error':(form.controls['EmailAddress'].touched && form.controls['EmailAddress'].invalid)}" #email/>
            <div class="invalid-feedback" *ngIf="form.controls['EmailAddress'].touched && form.controls['EmailAddress'].invalid">
                {{getErrorEmail()}}
            </div>
      </div>

      <div class="form-group col-md-6">
        <button  class="btn btn-block m-clr" [disabled]="!form.valid"><i class="fa fa-save" style="margin-right:5px"></i>Reset Password</button>
      </div>
      <div class="form-group col-md-6">
        <button class="btn btn-sm btn-default pull-right" routerLink="/login"><i class="fa fa-undo" style="margin-right:5px"></i>Cancel</button>
      </div>
      <!---->

    </div>
  </form>
</div>

</div>

</div>
</div>

</div>
